// App-wide constants

export const APP_CONSTANTS = {
  // Web app base URL
  WEB_APP_BASE_URL: 'https://app.saveforlater.pro',

  // API base URL
  API_BASE_URL: 'https://api1.saveforlater.pro/api',

  // Auth endpoints
  AUTH_ENDPOINTS: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    ACCOUNT: '/account'
  },

  // App download (for public folder / marketing pages)
  APP_DOWNLOAD: {
    IOS: 'https://apps.apple.com/us/app/save-for-later-organize-read/id6747046608', // Replace with real App Store ID
    ANDROID: 'https://play.google.com/store/apps/details?id=co.offtopic.bookmark', // Replace with real package
  },

  // Extension settings
  EXTENSION: {
    NAME: 'Bookmark Manager',
    VERSION: '0.0.1',
    STORAGE_KEYS: {
      BOOKMARKS: 'bookmarks',
      AUTH_TOKEN: 'bookmarker_auth_token',
      USER_DATA: 'bookmarker_user',
      SETTINGS: 'settings',
      SYNC_STATUS: 'syncStatus'
    }
  }
} as const;

// Helper function to get full web app URL
export const getWebAppUrl = (path: string = ''): string => {
  return `${APP_CONSTANTS.WEB_APP_BASE_URL}${path}`;
};

// Helper function to get login URL
export const getLoginUrl = (): string => {
  return getWebAppUrl(APP_CONSTANTS.AUTH_ENDPOINTS.LOGIN);
};

// Helper function to get register URL
export const getRegisterUrl = (): string => {
  return getWebAppUrl(APP_CONSTANTS.AUTH_ENDPOINTS.REGISTER);
};

// Helper function to get account URL
export const getAccountUrl = (): string => {
  return getWebAppUrl(APP_CONSTANTS.AUTH_ENDPOINTS.ACCOUNT);
};

/** UTM params for app download link tracking */
export interface AppDownloadUtmParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
}

const DEFAULT_APP_DOWNLOAD_UTM: AppDownloadUtmParams = {
  utm_source: 'web',
  utm_medium: 'cta',
  utm_campaign: 'app_download',
};

/** Append UTM params to a URL for app download tracking */
export function getAppDownloadUrl(
  baseUrl: string,
  overrides: AppDownloadUtmParams = {}
): string {
  const params = new URLSearchParams();
  const merged = { ...DEFAULT_APP_DOWNLOAD_UTM, ...overrides };
  (Object.keys(merged) as (keyof AppDownloadUtmParams)[]).forEach((key) => {
    const value = merged[key];
    if (value) params.set(key, value);
  });
  const separator = baseUrl.includes('?') ? '&' : '?';
  return params.toString() ? `${baseUrl}${separator}${params.toString()}` : baseUrl;
}
